import { environment } from '../../../environments/environment';
import * as firebase from "firebase/app"

import "firebase/auth"
import "firebase/storage"
import "firebase/firestore"

firebase.initializeApp(environment.firebaseConfig)

export default firebase